import {ResolveFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';
import {User} from '../models/users';
import { STATUS_OKAY } from '../models/state';

export const statusAgentsResolver: ResolveFn<boolean> = (route, state) => {

  const router = inject(Router);
  const translate = inject(TranslateService);

  const user: User = JSON.parse(localStorage.getItem('logged_in_agent') || '{}');

  if (localStorage.getItem('status_agent') == STATUS_OKAY ||  user.role != "agent") {
    return true;
  }else {

    Swal.fire({
      allowEscapeKey: false,
      title: translate.instant('agent.alert.notActive.title'),
      text: translate.instant('agent.alert.notActive.text', { status: STATUS_OKAY }),
      icon: 'info',
      iconColor: '#000000',
      confirmButtonText: translate.instant('agent.common.understood'),
      confirmButtonColor: '#000000',
      background: '#f8f9fa',
      color: '#212529',
      customClass: {
        popup: 'rounded-3 shadow',
        confirmButton: 'px-4 py-2',
      }
    }).then(() => {
      location.reload(); // o cualquier otra acción
    });

    //alert("No hay agentes disponibles")

    router.navigate(['/layout']);
    return false;
  }
};
